<template>
  <textarea
    class="textarea"
    :class="[
      variantClasses,
      sizeClasses,
      {
        'textarea-error': error,
        'textarea-disabled': disabled
      }
    ]"
    :disabled="disabled"
    :placeholder="placeholder"
    :rows="rows"
    :value="modelValue"
    v-bind="$attrs"
    @input="handleInput"
    @blur="handleBlur"
    @focus="handleFocus"
  />
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  rows: {
    type: [Number, String],
    default: 3
  },
  variant: {
    type: String,
    default: 'default',
    validator: val => ['default', 'filled', 'outline'].includes(val)
  },
  size: {
    type: String,
    default: 'md',
    validator: val => ['sm', 'md', 'lg'].includes(val)
  },
  disabled: {
    type: Boolean,
    default: false
  },
  error: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'blur', 'focus'])

const variantClasses = computed(() => {
  switch (props.variant) {
    case 'filled':
      return 'bg-surface-container-low border-outline-variant text-on-surface focus:border-secondary focus:bg-surface-container-lowest'
    case 'outline':
      return 'bg-transparent border-outline text-on-surface focus:border-secondary focus:bg-surface-container-low'
    case 'default':
    default:
      return 'bg-surface-container-low border-outline-variant text-on-surface focus:border-secondary hover:border-outline'
  }
})

const sizeClasses = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'textarea-sm'
    case 'lg':
      return 'textarea-lg'
    case 'md':
    default:
      return ''
  }
})

const handleInput = event => {
  emit('update:modelValue', event.target.value)
}

const handleBlur = event => {
  emit('blur', event)
}

const handleFocus = event => {
  emit('focus', event)
}
</script>
